import { patientName, capitalize } from 'Data/format.js'
export function format(person, type) {
  return `${patientName(person).trim()}, ${capitalize(type)}`
}
